import moment from 'moment';
import { Path, PathFilter } from '../api/generated';
import { FilterIds } from '../../../constants/filterIds';

const toSingleFilter = (filter: PathFilter[] = [], filterId: number) => {
    var temp: string[] = [];

    filter.forEach((value) => {
        if (value.filterId === filterId && value.filterValues) {
            temp.push(value.filterValues);
        }
    });
    return temp;
};

const toInput = (p: Path) => ({
    pathId: p?.pathId,
    name: p?.name ?? '',
    activeStart: p?.activeStart ?? moment().toString(),
    activeEnd: p?.activeEnd ?? moment('12/31/2099', 'MM/DD/YYYY').toString(),
    states: toSingleFilter(p.pathFilterModels ?? [], FilterIds.State),
    origins: toSingleFilter(p.pathFilterModels ?? [], FilterIds.Origin),
    paycycles: toSingleFilter(p.pathFilterModels ?? [], FilterIds.PayCycle),
    customerTypes: toSingleFilter(p.pathFilterModels ?? [],FilterIds.CustomerType),
    pathModels: p?.pathModels ?? [],
    pathType:p?.pathType
});
export const factory = {
    fromPathToInput: (p: Path) => toInput(p),
};
